/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Spacing_LabelInputs */

const en_styles_spacing_label = /** @type {(inputs: Styles_Spacing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spacing`)
};

const fr_styles_spacing_label = /** @type {(inputs: Styles_Spacing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espacement`)
};

const de_styles_spacing_label = /** @type {(inputs: Styles_Spacing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abstand`)
};

const it_styles_spacing_label = /** @type {(inputs: Styles_Spacing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spaziatura`)
};

const ru_styles_spacing_label = /** @type {(inputs: Styles_Spacing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Расстояние`)
};

const es_styles_spacing_label = /** @type {(inputs: Styles_Spacing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espaciado`)
};

const zh_cn2_styles_spacing_label = /** @type {(inputs: Styles_Spacing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`间距`)
};

const ja_styles_spacing_label = /** @type {(inputs: Styles_Spacing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`間隔`)
};

const hi_styles_spacing_label = /** @type {(inputs: Styles_Spacing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंतर`)
};

const pt_pt2_styles_spacing_label = /** @type {(inputs: Styles_Spacing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espaçamento`)
};

/**
* | output |
* | --- |
* | "Spacing" |
*
* @param {Styles_Spacing_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_spacing_label = /** @type {((inputs?: Styles_Spacing_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Spacing_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_styles_spacing_label(inputs)
	if (locale === "de") return de_styles_spacing_label(inputs)
	if (locale === "it") return it_styles_spacing_label(inputs)
	if (locale === "ru") return ru_styles_spacing_label(inputs)
	if (locale === "es") return es_styles_spacing_label(inputs)
	if (locale === "zh-CN") return zh_cn2_styles_spacing_label(inputs)
	if (locale === "ja") return ja_styles_spacing_label(inputs)
	if (locale === "hi") return hi_styles_spacing_label(inputs)
	if (locale === "pt-PT") return pt_pt2_styles_spacing_label(inputs)
	return en_styles_spacing_label(inputs)
});